<template>
  <div id="app">
    <router-view/>
    <!-- 审核界面 -->
    <el-dialog title="修改密码" :close-on-click-modal="false" :close-on-press-escape="false" v-if="editFormVisible" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="原密码：" prop="password">
          <el-input size="small" type="password" v-model="editForm.password" auto-complete="off" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPassword">
          <el-input size="small" type="password" v-model="editForm.newPassword" auto-complete="off" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="isPassword">
          <el-input size="small" type="password" v-model="editForm.isPassword" auto-complete="off" placeholder="请确认新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitFormA('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changePassword } from '@/api/payMG'
export default {
    name: "App",
    data() {
      return {
        editFormVisible: false,
        editForm: {},
        rules: {
          password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
          newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
          isPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        },
      }
    },
    beforeDestroy() {
      localStorage.clear()
    },
    mounted(){
      this.$bus.$on('updatePassword',this.updatePassword)
    },
    methods: {
      updatePassword(e){
        this.editFormVisible = true
      },
      closeDialog(){
        this.editFormVisible = false
        this.editForm = {}
      },
      submitFormA(editData) {
        if(!this.editForm.newPassword || this.editForm.newPassword.length < 6){
          return this.$message.error('新密码最少输入6位！')
        }
        this.$refs[editData].validate(valid => {
          if (valid) {
             if(this.editForm.isPassword == this.editForm.newPassword){
              changePassword(this.editForm)
              .then(res => {
                this.editFormVisible = false
                if (res.success) {
                  this.editForm = {}
                  this.$message({
                    type: 'success',
                    message: res.message
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('修改失败，请稍后再试！')
              })
             }else{
              this.$message.error('新密码与确认密码不一致，请重新输入！')
             }
          } else {
            return false
          }
        })
      },
    },
    watch: {
      editFormVisible(newVal){
        if(newVal == false){
          this.editForm = {}
        }
      }
    }
};
</script>

<style> 
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
    background-color: #F8F8F8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue